import { MenuDetail } from "./components/menuDetail";
export default MenuDetail;
